var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isScheduled && !_vm.isEmpty,
          expression: "isScheduled && !isEmpty",
        },
      ],
      staticClass:
        "body-container page-links no-images show-all-items textual_menu--section",
      attrs: { "data-section-id": _vm.section.ms_id },
    },
    [
      _c("div", {
        staticClass: "page-link-group-hash",
        attrs: { id: _vm.section.ms_id + "-MS" },
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "page-links", attrs: { tabindex: "-1" } }, [
        _vm._v(_vm._s(_vm.section.ms_title)),
      ]),
      _vm._v(" "),
      _vm.section.ms_subtitle.length
        ? _c("h3", {
            staticClass: "textual_menu--section_subtitle",
            domProps: { innerHTML: _vm._s(_vm.section.ms_subtitle) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.section.ms_content_area_top.length
        ? _c("div", { staticClass: "page-link-group-copy" }, [
            _c("div", {
              staticClass: "viewport",
              domProps: { innerHTML: _vm._s(_vm.section.ms_content_area_top) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "viewport",
          class: _vm.sectionContentClasses(_vm.section),
        },
        [
          _c(
            "div",
            { staticClass: "body-container-scroller" },
            _vm._l(_vm.items, function (item, itemIndex) {
              return _c("default-item", {
                key: "item-" + item.mi_id,
                style: { "--item-rows": _vm.maxItemRows },
                attrs: { item: item, "item-index": itemIndex, menu: _vm.menu },
                on: { rows: _vm.handleItemRows },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "page-link-view-more btn",
              attrs: { href: "#" + _vm.section.ms_id + "-MS" },
            },
            [_vm._v("VIEW MORE")]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.section.ms_content_area_bottom.length ||
      _vm.section.menu_items?.length
        ? _c(
            "div",
            { staticClass: "page-link-group-copy" },
            [
              (_vm.section.menu_items || []).length
                ? _c("menu-tag-legend", {
                    attrs: {
                      items: _vm.section.menu_items || [],
                      "menu-type": "textual",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.section.ms_content_area_bottom.length
                ? _c("div", {
                    staticClass: "viewport",
                    domProps: {
                      innerHTML: _vm._s(_vm.section.ms_content_area_bottom),
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.section.ms_menu_version_override || _vm.menu?.menu_version
        ? _c("menu-version", {
            attrs: {
              version:
                _vm.section.ms_menu_version_override ||
                _vm.menu?.menu_version ||
                "",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }